import { ContentService } from './content-service';
import { queryClient } from '../query-client';
export const contentService = new ContentService({
    resource: 'content',
    parentResources: [],
    middleware: [],
    queryClient,
});
